import React from "react";

const DashboardPanel = (props) => {
  const { title, headerAction, footer, withBorder, theme, className } = props;

  const classes = [
    "panel",
    theme,
    className,
  ];
  const headerClasses = [
    "header",
    withBorder ? "withBorder" : null,
  ];
  const bodyClasses = [
    "body",
    footer ? "withFooter" : null,
  ];
  const footerElem = footer && (
    <div className="footer">
      { footer }
    </div>
  );
  
  return (
    <div className={classes.join(" ")}>
      <div className={headerClasses.join(" ")}>
        <div className="bgColorTheme" />
        <h1>{ title }</h1>
        <div className="dashboardHeaderAction">{ headerAction }</div>
      </div>
      <div className={bodyClasses.join(" ")}>
        { props.children }
      </div>
      { footerElem }
    </div>
  );
}

export default DashboardPanel;